import React, { useEffect, useState } from "react";
import TableCell from "@material-ui/core/TableCell";
import { FormattedMessage } from "react-intl";
import { CustomTableRow, TableIconCell } from "../../../components/table";
import Link from "components/link";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import withStyles from "../../../components/with-styles";
import styles from "./styles.css.js";
import { getUserContracts, getUserCustomers } from "../../../services/commonService";
import ApiConnectedPaginatedTable from "../../../components/table/paginated-table/api-connected-paginated-table";
import { useAuthDataContext } from "../../../components/auth";
import { useMutation } from "@apollo/react-hooks";
import mutation from "./mutation";
import Icon from "components/icon";
import DeleteActionWithModal from "../../../components/buttons/action-button/delete-action-with-modal";
import { Restricted, permissions } from "components/auth";
import IconButton from "components/icon-button";
import TableRow from "@material-ui/core/TableRow";
import { HeaderCell } from "components/table";
import { useCurrentCustomerContext } from "../../../components/current-customer-context";

const Header = () => (
  <TableRow>
    <HeaderCell>
      <FormattedMessage id="common.description" />
    </HeaderCell>
    <TableIconCell />
  </TableRow>
);

const StyledHeaderComponent = withStyles(styles)(Header);

const RowComponent = ({ item, refetchData }) => {
  const detailsUrl = `/customer/details/${item._id}`;
  const [deleteCustomer] = useMutation(mutation);

  return (
    <CustomTableRow key={item._id} href={detailsUrl}>
      <TableCell>{item.description}</TableCell>
      <TableIconCell>
        <Link href={detailsUrl} target="_blank" rel="noopener">
          <IconButton>
            <Icon name="launch" />
          </IconButton>
        </Link>
        <Restricted permissions={[permissions.customer_manage]}>
          <Link href={`/customer/edit/${item._id}`}>
            <IconButton>
              <Icon name="edit" />
            </IconButton>
          </Link>
          <DeleteActionWithModal
            mutation={deleteCustomer}
            mutationVariables={{
              customerId: item._id,
            }}
            elementNameInResult="deleteCustomer"
            elementToDelete={item.codename}
            refetchDataOnSuccess
            refetchData={refetchData}
          />
        </Restricted>
      </TableIconCell>
    </CustomTableRow>
  );
};

RowComponent.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
  /**
   ** Referencia con el último evento de la anterior grabación de la página
   **/
  previousEvent: PropTypes.object,
};

const StyledI18nRowComponent = withStyles(styles)(injectIntl(RowComponent));

const CustomersPaginatedTable = ({ onClickRow, selectedRowId }) => {
  const { user } = useAuthDataContext();

  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(5);

  const handleSetPage = value => {
    setPage(value);
  };

  const handleSetPerPage = value => {
    setPerPage(value);
  };

  const [elements, setElements] = useState(null);
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState(null);
  const [total, setTotal] = useState(null);

  const callback = response => {
    setLoading(false);
    setElements(response.data);
    setTotal(parseInt(response.headers["pagination-total-results"]));
  };

  const errorCallback = value => {
    setLoading(false);
    setError(value);
  };

  useEffect(
    () => {
      const variables = { page, perPage, limit: perPage, username: user?.sub };
      getUserCustomers(variables, callback, errorCallback);
    },
    [page, perPage],
  );

  return (
    <ApiConnectedPaginatedTable
      APIPetition={getUserCustomers}
      headerComponent={StyledHeaderComponent}
      rowComponent={StyledI18nRowComponent}
      paginatedElementsHandler={data => data}
      page={page}
      onChangePage={handleSetPage}
      onChangePerPage={handleSetPerPage}
      rowProps={{ onClick: onClickRow, selectedRowId }}
      elements={elements}
      loading={loading}
      error={error}
      total={total}
      perPage={perPage}
      noDataMessage={"customers.no_data"}
    />
  );
};

CustomersPaginatedTable.propTypes = {
  /**
   ** Página a cargar en la tabla
   **/
  page: PropTypes.number,
  /**
   ** Objeto que contiene los filtrados de la búsqueda
   **/
  variables: PropTypes.object,
  /**
   ** Componente que se mostrará en el pie de la tabla
   **/
  footer: PropTypes.element,
};

export default withStyles(styles)(CustomersPaginatedTable);
